export default __webpack_public_path__ + "static/4-2_Lense_Specifications-17576aa170a8283864c81eef5044b466.webp";